module.exports = __webpack_public_path__ + "assets/twitter.c246c8aa.svg";